// File: assets/page-project-proposal.js

import { initHtmlExporter } from './htmlExporter.js';

/**
 * Подгружает сниппеты [data-include] и после всех include запускает callback.
 * @param {Function} callback
 */
function includeHTML(callback) {
  const els = document.querySelectorAll('[data-include]');
  let remaining = els.length;
  if (!remaining) return callback && callback();
  els.forEach(el => {
    fetch(el.getAttribute('data-include'))
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(html => {
        el.outerHTML = html;
        if (--remaining === 0) includeHTML(callback);
      })
      .catch(() => {
        if (--remaining === 0) includeHTML(callback);
      });
  });
}

function initPage() {
  // 1. Footer year
  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // 2. Navigation logic
  const headerNav = document.querySelector('header.site-nav');
  if (headerNav) {
    const toggleBtn = headerNav.querySelector('.nav-toggle');
    const menuLinks = headerNav.querySelectorAll('nav a');
    toggleBtn.addEventListener('click', e => {
      e.stopPropagation();
      const open = headerNav.getAttribute('aria-expanded') === 'true';
      headerNav.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    document.addEventListener('click', e => {
      if (
        headerNav.getAttribute('aria-expanded') === 'true' &&
        !headerNav.contains(e.target)
      ) {
        headerNav.setAttribute('aria-expanded', 'false');
      }
    });
    menuLinks.forEach(a => {
      a.addEventListener('click', () => {
        headerNav.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // 3. Section reveal & menu highlight
  const navLinks = document.querySelectorAll('.site-nav a');
  const sections = document.querySelectorAll('.section[id]');
  const io = new IntersectionObserver(
    entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          navLinks.forEach(l => {
            l.classList.remove('active');
            l.removeAttribute('aria-current');
          });
          const cur = document.querySelector(`.site-nav a[href="#${e.target.id}"]`);
          if (cur) {
            cur.classList.add('active');
            cur.setAttribute('aria-current', 'page');
          }
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -20% 0px' }
  );
  sections.forEach(s => io.observe(s));

  // 4. Site Previews (как в вашем preview-section.html)

  // 5. Add-ons logic (как было)

  // 6. Terms accordion (как было)

  // 7. Signature pad
  (function() {
    const canvas = document.getElementById('signature-pad');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#1B1B1B';
    ctx.lineWidth   = 2;
    ctx.lineJoin    = 'round';
    ctx.lineCap     = 'round';
    let drawing = false, lastX = 0, lastY = 0;
    function getPos(e) {
      const rect  = canvas.getBoundingClientRect();
      const style = getComputedStyle(canvas);
      const borderLeft = parseFloat(style.borderLeftWidth),
            borderTop  = parseFloat(style.borderTopWidth);
      let x = (e.touches ? e.touches[0].clientX : e.clientX)
              - rect.left - borderLeft;
      let y = (e.touches ? e.touches[0].clientY : e.clientY)
              - rect.top  - borderTop;
      const scaleX = canvas.width  / (rect.width  - borderLeft * 2),
            scaleY = canvas.height / (rect.height - borderTop  * 2);
      return { x: x * scaleX, y: y * scaleY };
    }
    function start(e) { e.preventDefault(); drawing = true; ({ x: lastX, y: lastY } = getPos(e)); }
    function draw(e)  { if (!drawing) return; e.preventDefault(); const pos = getPos(e);
      ctx.beginPath(); ctx.moveTo(lastX, lastY); ctx.lineTo(pos.x, pos.y); ctx.stroke();
      lastX = pos.x; lastY = pos.y;
    }
    function stop(e)  { if (!drawing) return; e.preventDefault(); drawing = false; }

    ['mousedown','touchstart'].forEach(evt => canvas.addEventListener(evt, start, { passive: false }));
    ['mousemove','touchmove'].forEach(evt => canvas.addEventListener(evt, draw,  { passive: false }));
    ['mouseup','mouseleave','touchend'].forEach(evt => canvas.addEventListener(evt, stop));

    document.getElementById('clear-signature').onclick = () =>
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    document.getElementById('save-signature').onclick = () => {
      const link = document.createElement('a');
      link.href    = canvas.toDataURL('image/png');
      link.download = 'signature.png';
      link.click();
    };
    document.getElementById('upload-signature').onchange = e => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = evt => {
        const img = new Image();
        img.onload = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        };
        img.src = evt.target.result;
      };
      reader.readAsDataURL(file);
    };
  })();

  // 8. HTML Exporter
  const exportBtn = document.getElementById('editor-export-html');
  initHtmlExporter(exportBtn);
}

document.addEventListener('DOMContentLoaded', () => includeHTML(initPage));
